import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import leftarrow from '../../../safreeimg/left-arrow.png';


const CouponSend = () => {
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const couponId = window.location.hash.substring(1);

    const rowsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                const response = await axios.get('https://api.safree.org/api-v2022/superAdmin/auth/v1/get/basic/users', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.data.success) {
                    setUsers(response.data.data);
                } else {
                    setError('Failed to fetch users');
                }
            } catch (err) {
                console.error('Error fetching users:', err);
                setError('An error occurred while fetching users: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const filteredUsers = users.filter((user) =>
        user.name && user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
    const currentRows = filteredUsers.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const maxPageNumbersToShow = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleSelectUser = (userId) => {
        setSelectedUsers((prevSelected) => {
            if (prevSelected.includes(userId)) {
                return prevSelected.filter((id) => id !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectedUsers.length === filteredUsers.length) {
            setSelectedUsers([]); // Deselect all
        } else {
            setSelectedUsers(filteredUsers.map((user) => user.userId)); // Select all
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedUsers.length === 0) {
            alert('Please select at least one user.');
            return;
        }

        try {
            setIsSubmitting(true);
            const token = localStorage.getItem('token');
            if (!token) {
                alert('No authentication token found');
                return;
            }

            const response = await axios.post(
                'https://api.safree.org/api-v2022/superAdmin/auth/v1/send/coupon/notification',
                {
                    userIds: selectedUsers,
                    couponId: couponId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                setSelectedUsers([]);
                alert('Coupon sent successfully!');
            } else {
                alert('Failed to send Coupon');
            }
        } catch (err) {
            console.error('Error sending Coupon:', err);
            alert('An error occurred while sending Coupon: ' + err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;
    if (error) return <div>Error: {error}</div>;

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <div className="container user-management">
            <div className="row header">
                <div className="col-md-12">
                    <p className="sub-heading"><img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> Send Coupon & Discount</p>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="form-group clgpfom">
                        <input
                            type="text"
                            id="search"
                            className="form-control"
                            placeholder="Search by name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="table-container tblmnual">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={selectedUsers.length === filteredUsers.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>S. No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((user, index) => (
                                    <tr key={user.userId}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedUsers.includes(user.userId)}
                                                onChange={() => handleSelectUser(user.userId)}
                                            />
                                        </td>
                                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={() => handlePageChange('prev')}
                                disabled={currentPage === 1}
                            >
                                &laquo; Prev
                            </button>
                            {getPageNumbers().map((page) => (
                                <button
                                    key={page}
                                    className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(page)}
                                >
                                    {page}
                                </button>
                            ))}
                            <button
                                className="pagination-btn"
                                onClick={() => handlePageChange('next')}
                                disabled={currentPage === totalPages}
                            >
                                Next &raquo;
                            </button>
                            <form className='onsub' onSubmit={handleSubmit}>
                            <button type="submit" className="btn btn-submits">
                                {isSubmitting ? (
                                    <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status"></div>
                                ) : (
                                    'Send Coupon'
                                )}
                            </button>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CouponSend;
